// extracted by mini-css-extract-plugin
export default {"recos":"N3-z","productCardOverride":"O3-z","rowHasBadge":"P3-z"};